export const DEFAULT_INIT = { cachetoken: "", threedinit: "" };
